// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__hfT6U","colMin":"styles_colMin__3cOVI"};